import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { createQuizTemplateRequested } from 'features/quizzes/actions';

export function* createQuizTemplateSaga(action: ReturnType<typeof createQuizTemplateRequested>) {
  yield call(SignalingSocket.send, { event: 'createQuizTemplate', data: action.payload });
}
